import { type ApiSuccessResponse, type DashboardStat } from '../../common/types';
import { apiSlice } from '../../app/services/api-slice';

const tagName: string = 'Dashboard';

const tagApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: [tagName]
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getGlobalDashboard: builder.query<DashboardStat, void>({
        query: () => '/dashboard',
        transformResponse: (data: ApiSuccessResponse) => {
          return data.data as DashboardStat;
        },
        providesTags: (result) => [{ type: tagName, id: 'LIST' }]
      }),
      getAgencyDashboard: builder.query<DashboardStat, string>({
        query: (agencyId: string) => `/dashboard/by-agency/${agencyId}`,
        transformResponse: (data: ApiSuccessResponse) => {
          return data.data as DashboardStat;
        },
        providesTags: (result) => (result != null ? [{ type: tagName }] : [])
      }),
      getMerchantDashboard: builder.query<DashboardStat, string>({
        query: (merchantId: string) => `/dashboard/by-merchant/${merchantId}`,
        transformResponse: (data: ApiSuccessResponse) => {
          return data.data as DashboardStat;
        },
        providesTags: (result) => (result != null ? [{ type: tagName }] : [])
      }),
      getStoreDashboard: builder.query<DashboardStat, string>({
        query: (storeId: string) => `/dashboard/by-store/${storeId}`,
        transformResponse: (data: ApiSuccessResponse) => {
          return data.data as DashboardStat;
        },
        providesTags: (result) => (result != null ? [{ type: tagName }] : [])
      })
    }),
    overrideExisting: false
  });

export const {
  useGetGlobalDashboardQuery,
  useGetAgencyDashboardQuery,
  useGetMerchantDashboardQuery,
  useGetStoreDashboardQuery
} = tagApi;
